import React, { Component } from 'react';
import './SmallText.css';
import Utils from '../../../base/Utils';

class SmallText extends Component {
    availableColors = ['Light', 'Dark', 'Bad'];
    
    render() {
        var text = this.props.text;
        var customColor = this.props.customColor;
        var color = Utils.checkAvailability(this.availableColors, this.props.color, true);
        
        var classValue = "SmallText " + color;
        
        var html = <div className={classValue} style={{color: customColor}}>{text}</div>;
        
        return html;
    }
}

export default SmallText;
